function sanitizeNull<T>(obj: T): T {
  return JSON.parse(
    JSON.stringify(obj, (_, value) => {
      return value === null ? undefined : value
    })
  )
}

export { sanitizeNull }
